/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_1_TitleInputs */

const en_privacy_section_1_title = /** @type {(inputs: Privacy_Section_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduction`)
};

const lv_privacy_section_1_title = /** @type {(inputs: Privacy_Section_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Ievads`)
};

/**
* | output |
* | --- |
* | "1. Introduction" |
*
* @param {Privacy_Section_1_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_1_title = /** @type {((inputs?: Privacy_Section_1_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_1_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_1_title(inputs)
	return en_privacy_section_1_title(inputs)
});